/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Zavřeno`
};

const da_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Lukket`
};

const de_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Geschlossen`
};

const en_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Closed`
};

const es_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Cerrado`
};

const fr_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Fermé`
};

const hu_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Zárva`
};

const it_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Chiuso`
};

const nl_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Gesloten`
};

const pl_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Zamknięte`
};

const pt_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Fechado`
};

const sv_closed = /** @type {(inputs: {}) => string} */ () => {
	return `Stängt`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const closed = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.closed(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("closed", locale)
	if (locale === "cs") return cs_closed(inputs)
	if (locale === "da") return da_closed(inputs)
	if (locale === "de") return de_closed(inputs)
	if (locale === "en") return en_closed(inputs)
	if (locale === "es") return es_closed(inputs)
	if (locale === "fr") return fr_closed(inputs)
	if (locale === "hu") return hu_closed(inputs)
	if (locale === "it") return it_closed(inputs)
	if (locale === "nl") return nl_closed(inputs)
	if (locale === "pl") return pl_closed(inputs)
	if (locale === "pt") return pt_closed(inputs)
	return sv_closed(inputs)
};